var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentResumeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1518 4.67321L11.633 0.154477C11.5341 0.055582 11.4 0 11.2602 0H3.63478C2.56536 0 1.69531 0.870047 1.69531 1.93946V16.0605C1.69531 17.13 2.56536 18 3.63474 18H14.3668C15.4362 18 16.3062 17.13 16.3062 16.0605V5.04608C16.3062 4.90623 16.2507 4.77211 16.1518 4.67321ZM11.7875 1.80046L14.5058 4.51874H12.6723C12.1844 4.51874 11.7875 4.12182 11.7875 3.634V1.80046ZM14.3668 16.9453H3.63474C3.14691 16.9453 2.75 16.5484 2.75 16.0605V1.93946C2.75 1.4516 3.14691 1.05469 3.63474 1.05469H10.7328V3.634C10.7328 4.70338 11.6028 5.57343 12.6722 5.57343H15.2516V16.0605C15.2516 16.5484 14.8546 16.9453 14.3668 16.9453Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5179 14.6865H4.48047C4.18923 14.6865 3.95312 14.9226 3.95312 15.2139C3.95312 15.5051 4.18923 15.7412 4.48047 15.7412H13.5179C13.8092 15.7412 14.0453 15.5051 14.0453 15.2139C14.0453 14.9226 13.8092 14.6865 13.5179 14.6865Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5179 12.4263H4.48047C4.18923 12.4263 3.95312 12.6624 3.95312 12.9536C3.95312 13.2448 4.18923 13.481 4.48047 13.481H13.5179C13.8092 13.481 14.0453 13.2448 14.0453 12.9536C14.0453 12.6624 13.8092 12.4263 13.5179 12.4263Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5179 10.1675H4.48047C4.18923 10.1675 3.95312 10.4036 3.95312 10.6948C3.95312 10.9861 4.18923 11.2222 4.48047 11.2222H13.5179C13.8092 11.2222 14.0453 10.9861 14.0453 10.6948C14.0453 10.4036 13.8092 10.1675 13.5179 10.1675Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48047 8.96191H11.2586C11.5498 8.96191 11.7859 8.7258 11.7859 8.43457C11.7859 8.14334 11.5498 7.90723 11.2586 7.90723H4.48047C4.18923 7.90723 3.95312 8.14334 3.95312 8.43457C3.95312 8.7258 4.18923 8.96191 4.48047 8.96191Z",
    fill: "#494949",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48047 6.7025H7.8695C8.16073 6.7025 8.39684 6.46639 8.39684 6.17516V2.78613C8.39684 2.4949 8.16073 2.25879 7.8695 2.25879H4.48047C4.18923 2.25879 3.95312 2.4949 3.95312 2.78613V6.17516C3.95312 6.46639 4.18923 6.7025 4.48047 6.7025ZM5.00781 3.31348H7.34215V5.64782H5.00781V3.31348Z",
    fill: "#494949",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentResumeIcon);
export default __webpack_public_path__ + "static/media/student_resume_icon.d3286fdde97eb087d8f319b341b25fcc.svg";
export { ForwardRef as ReactComponent };